<div class="m-popup"
     :class="{ 'm--is-inline': hasTriggerSlot }">
    <m-popper v-if="!isSidebarUsed"
              :id="id"
              :open="popperOpen"
              @update:open="onPopperOpen"
              :disabled="disabled"
              :class-name="className"
              :placement="placement"
              :focus-management="focusManagement"
              :open-trigger="propOpenTrigger"
              :trigger="propTrigger"
              :lazy="lazy"
              :before-enter="beforeEnter"
              :enter="enter"
              :after-enter="afterEnter"
              :enter-cancelled="enterCancelled"
              :before-leave="beforeLeave"
              :leave="leave"
              :after-leave="afterLeave"
              :leave-cancelled="leaveCancelled"
              :shadow="shadow"
              :padding="padding"
              :padding-header="paddingHeader"
              :padding-body="paddingBody"
              :padding-footer="paddingFooter"
              :preload="preload"
              :width="width"
              :background="background"
              :close-on-click-outside="closeOnBackdrop"
              @open="onOpen"
              @close="onClose"
              @portal-mounted="onPortalMounted"
              @portal-after-open="onPortalAfterOpen"
              ref="popper">
        <div slot="trigger"
             v-if="hasTriggerSlot">
            <slot name="trigger"></slot>
        </div>
        <slot name="header"
              slot="header"></slot>
        <slot></slot>
        <slot name="footer"
              slot="footer"></slot>
    </m-popper>
    <m-sidebar v-if="isSidebarUsed"
               :id="id"
               :open="sideBarOpen"
               @update:open="onSideBarOpen"
               :disabled="disabled"
               :class-name="className"
               :focus-management="focusManagement"
               :close-on-backdrop="closeOnBackdrop"
               :preload="preload"
               :lazy="lazy"
               :trigger="propTrigger"
               :padding="padding"
               :padding-header="paddingHeader"
               :padding-body="paddingBody"
               :padding-footer="paddingFooter"
               :open-trigger="propOpenTrigger"
               :full-height="sidebarFullHeight"
               @open="onOpen()"
               @close="onClose()"
               @portal-mounted="onPortalMounted"
               @portal-after-open="onPortalAfterOpen">
        <div slot="trigger"
             v-if="hasTriggerSlot">
            <slot name="trigger"></slot>
        </div>
        <slot name="header"
              slot="header"></slot>
        <slot></slot>
        <slot name="footer"
              slot="footer"></slot>
    </m-sidebar>
</div>
